import { useState, useEffect,useMemo } from "react";
import "./styles/PanelCis.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import ModalCreateCis from "./ModalCreateCis";
import CisList from "./CisList";
import LoadSimple from "../LoadSimple";
import TableCis from "./TableCis";
import InfoCis from "./InfoCis";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Paginador from "../generales/Paginador";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import ModalMenuHost from "./Events/ModalMenuHost"
import ImportCis from "./ImportCis";
import UpdateCis from "./UpdateCis";
import FilterPanel from './Events/FilterPanel'
import ActionsPanel from "./Events/ActionsPanel";
import ActiveFilterChips from './Events/ActiveFilterChips'
import ModalMain from "./ModalCreate/ModalMain;";
import {useFetch }from"../../hooks/useFetch";
import { permisos_codigo_id } from "../generales/GroupsId";
import { sub } from "date-fns";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "80%",
    padding: "20px",
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const infoCreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const PanelCis = ({buscar_auths,buscar_folios,server,languaje,mode,handleShowPopup,pendingList,FoliosList,users_catalog,userPermissions
 }) => {
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const [severityFilter, setSeverityFilter] = useState([6]);
  const [statusFilter, setStatusFilter] = useState(["PROBLEM", "RESOLVED"]);
  const [techFilter, setTechFilter] = useState([]);
  // console.log(techFilter)
  const [groupFilter, setGroupFilter] = useState([]);
  const [subgroupFilter, setSubGroupFilter] = useState([]);
  const [zoneFilter, setZoneFilter] = useState([]);
  const [serviceFilter, setServiceFilter] = useState([]);
  const [brandFilter, setBrandFilter] = useState([]);
  const [ackFilter, setAckFilter] = useState([]); // true / false / null
  const [ticketFilter, setTicketFilter] = useState([]);
  const [tipoFilter, setTipoFilter] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const filteredEvents = useMemo(() => {
       // return (searchTerm2 === "" ? (searchTerm === "" ? events:searchResults):(searchTerm === "" ? searchResults2:searchResults)).filter((e) => {
           // const matchesSearch =
         return dataUsers.data.filter((e) => {
//   
const matchesSearch = searchTerm === '' || 
                                 Object.values(e).some(value => {
                                     if (Array.isArray(value)) {
                                         return value.some(item => String(item).toLowerCase().includes(searchTerm.toLowerCase()));
                                     }
                                     return String(value).toLowerCase().includes(searchTerm.toLowerCase());
                                 });

                                 
              
          
          const matchesGroup =
          groupFilter.length === 0 ||
 groupFilter.some((group) => String(group.label).replaceAll(" ","") === String(e.group_name).replaceAll(" ","") );
 
const matchesSubGroup =
          subgroupFilter.length === 0 ||
 subgroupFilter.some((group) => Number(group.value) === Number(e.ci_group_id));

    const matchesZone =
 zoneFilter.length === 0 ||
 zoneFilter.some((zone) => Number(zone.value) === Number(e.location_id));

 const matchesService =
 serviceFilter.length === 0 ||
 serviceFilter.some((serv) => Number(serv.value) === Number(e.service_id));
 const matchesBrand =
 brandFilter.length === 0 ||
 brandFilter.some((brand) => Number(brand.value) === Number(e.brand_id));
 //   const matchesAck =
 // ackFilter.length === 0 || ackFilter.length === 2 ||
 // (ackFilter.includes(1) && e.acknowledges_concatenados != null && e.acknowledges_concatenados !== "") ||
 // (ackFilter.includes(0) && (e.acknowledges_concatenados == null || e.acknowledges_concatenados === ""));
   
saveFiltersToLocalStorage()
setPageActual(1)
setLimitList(50)
 
  return (
              
               matchesSearch &&
               matchesService &&
               matchesBrand &&
               matchesGroup &&
               matchesSubGroup &&
               matchesZone 
           );
       });
        
   }, [dataUsers.data,subgroupFilter, groupFilter, zoneFilter,searchTerm,serviceFilter,brandFilter]);

  function saveFiltersToLocalStorage() {
      const filtersState = {
          searchTerm: searchTerm,
          services: serviceFilter,
          brands: brandFilter,
          groups:groupFilter ,
          subgroups:subgroupFilter ,
          zones:zoneFilter ,
      };
      localStorage.setItem('eventFilters', JSON.stringify(filtersState));
  }
  function loadFiltersFromLocalStorage() {
      const savedFilters = localStorage.getItem('eventFilters');
      if (savedFilters) {
          const filters = JSON.parse(savedFilters);
          setSearchTerm(filters.searchTerm || '');
          setServiceFilter(filters.services || []);
          setBrandFilter(filters.brands || []);
          setGroupFilter(filters.groups || []);
          setSubGroupFilter(filters.subgroups || []);
          setZoneFilter(filters.zones || []);
          
      }
  }

  // console.log(filteredEvents);
  const [filters, setFilters] = useState(() => {
// Load initial state from local storage or set defaults
const savedFilters = localStorage.getItem('eventFilters');
return savedFilters
  ? JSON.parse(savedFilters)
  : {
      searchTerm: '',
      groups: [],
      zones: [],
      services: [],
      brands: [],
    };
});
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  const [isOpen, setIsOpen] = useState(false);
  const togglePanel = () => {
     setIsOpen(!isOpen);
     setIsOpenAct(false);
   };

  const [isOpenAct, setIsOpenAct] = useState(false);
  const togglePanelAct = () => {
   setIsOpen(false);
     setIsOpenAct(!isOpenAct);
   };
  const handleRemoveFilter = (filterType) => {
switch (filterType) {
  case 'service':
    setServiceFilter([]);
    break;
  case 'brand':
    setBrandFilter([]);
    break;
  case 'status':
    setStatusFilter([]);
    break;
  case 'severity':
    setSeverityFilter([]);
    break;
  case 'tech':
    setTechFilter([]);
    break;
  case 'group':
    setGroupFilter([]);
    break;
  case 'subgroup':
    setSubGroupFilter([]);
    break;
  case 'zone':
    setZoneFilter([]);
    break;
  case 'ack':
    setAckFilter([]);
    break;
  case 'ticket':
    setTicketFilter([]);
    break;
  case 'tipo':
    setTipoFilter([]);
    break;
  default:
    break;
}
};
  var dataList = filteredEvents.length > 0 ? filteredEvents : [];
  //////////////////////////////////////////////////////

  // var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);
  const [listSelected,setListSelected]=useState(1)
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [infoCisModalOpen, setinfoCisModalOpen] = useState(false);
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [poolRows,setPoolRows]=useState([])
  const [poolObjectRows,setPoolObjectRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [ImportModalOpen2, setImportModalOpen2] = useState(false);
  const [ActualizarModalOpen, setActualizarModalOpen] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const update_info = () => {
    setImportModalOpen2(true);
  };

  function closeImportModal2() {
    setSearchTerm("")
    setImportModalOpen2(false);
    setAllSelected(false)
    setPoolRows([])
    setPoolObjectRows([])
  }
  const import_info = () => {
    setImportModalOpen(true);
  };
  function closeImportModal() {
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const actualizar_info = () => {
   setActualizarModalOpen(true);
 };
  function closeActualizarModal() {
    setSearchTerm("")
    setActualizarModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const hadleChangeList=(e)=>{
      setListSelected(e)
  }
  const handleSearch = (query) => {
      // Aquí puedes realizar la búsqueda usando el valor de 'query'
      // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
      setSearchResult(`Resultados para: ${query}`);
    };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  const view = (elemento) => {
    // cisSelectRow(elemento)
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setinfoCisModalOpen(true);
  };
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;

  // console.log(dataUsers);
  // const [searchResult, setSearchResult] = useState(null);
  const [exportLoading,setExportLoading]=useState(false)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);

  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);

  function closCreateCisModal() {
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  function closinfoCisModal() {
   // setEditActive(false);
   setinfoCisModalOpen(false);
 }
  const handleChangEdit = (cis) => {
    setEditActive(true);
    setDataCis(cis);
    setCreateCisModalOpen(true);
    // buscar_cis(cis.element_id);
  };
  useEffect(() => {
      buscar_cis()
    
      
  }, []);
  const buscar_cis = () => {
     buscar_auths()
     buscar_folios()
   setLoadingCis(true)
   const fetchDataPost = async () => {
     try {
       const response = await fetch(
         server.url +
           "/api/v1/cassia/cis_v2/",
         {
           method: "GET",
           headers: {
             "Content-Type": "application/json",
             accept: "application/json",
             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
           },
         }
       );
       if (response.ok) {
         const data1 = await response.json();
         setLoadingCis(false)
         setDataUsers(data1);
         // setCreateCisModalOpen(true)
       } else {
         const data1 = await response.json();
         throw new Error("Error en la solicitud");
       }
     } catch (error) {
       console.error(error);
     }
   };

   fetchDataPost();
 };
  const regresar_cis = () => {
    setCisSelected([]);
    // setLoadingCis(true)
  };

  const generatePDF = () => {
    const input = document.getElementById("content");

    // Guardar el estado actual de visibilidad de los elementos que deseas ocultar
    const originalDisplay = [];
    const elementsToHide = input.querySelectorAll(".hiddenPDF");
    elementsToHide.forEach((element) => {
      originalDisplay.push(element.style.display);
      element.style.display = "none";
    });

    html2canvas(input).then((canvas) => {
      // Restaurar el estado original de visibilidad
      elementsToHide.forEach((element, index) => {
        element.style.display = originalDisplay[index];
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "PNG", 10, 10, 190, 100);
      pdf.save("CIs-" + obtenerFechaActualLocal() + ".pdf");
    });
  };

  function search_devices() {
    setDevices({ data: devices.data, loading: true, error: devices.error });

    const fetchData = async () => {
      try {
        //console.log(`Bearer ${token_item}`)
        const token =
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY"; // Reemplaza con tu token de autenticación
        // const response = await fetch(server.url+'/api/v1/zabbix/db/hosts/relations/'+ubicacion.groupid, {
        const devicefilter = "";
        const subtypefilter = "";
        let andAux = devicefilter !== "" ? "&" : "?";
        andAux = subtypefilter !== "" ? andAux : "";
        const response = await fetch(
          server.url + "/api/v1/zabbix/hosts/0",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const response_data = await response.json();
          setDevices({
            data: response_data.data,
            loading: false,
            error: devices.error,
          });
          setLoadingCis(false);
        } else {
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        // Manejo de errores
        setDevices({
          data: devices.data,
          loading: devices.loading,
          error: error,
        });
        //console.error(error);
      }
    };
    fetchData();
  }
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  const Exportar=(file_type)=>{
    
    let method='POST'
const body={
  "ci_ids": poolRows
}
    setExportLoading(true)
      const fetchDataPost = async () => {
        
     try {
       // console.log(localStorage.getItem('access_token'))
       const response = await fetch(server.url+'/api/v1/cassia/cis_v2/export_to_excel', {
         method: method,  
         headers: {
            "Accept": "application/json",
           // 'Content-Type': 'application/json',
           'Content-Type': 'application/json',
             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
           },
         body: JSON.stringify(body),
       });
       if (response.ok) {
        // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
     const blob = await response.blob();
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;

     // Dependiendo del tipo de archivo, nombramos el archivo a descargar
     if (file_type === 'json') {
       link.download = 'Hosts.json';
     } else if (file_type === 'csv') {
       link.download = 'Hosts.csv';
     } else if (file_type === 'excel') {
       link.download = 'Hosts.xlsx'; // Archivo de Excel
     }

     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     setAllSelected(false)
     setPoolRows([])
     setExportLoading(false);
     handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)
       } else {
         setExportLoading(false);
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
           setExportLoading(false);
        }
      };
  
      fetchDataPost();
      
}
  return (
    <>
    <div className='head-reportes' style={{height:'8%',justifyContent:'end'}}>
       {/* <div className="selected-range">
        <p>Rango seleccionado: {range[0] ? range[0].toLocaleString() : 'N/A'} - {range[1] ? range[1].toLocaleString() : 'N/A'}</p>
      </div> */}
      <div className='cont-chips-filters' style={{display:'flex',alignItems:'center',height:'100%',marginLeft:'10px',width:'90%'}}> 
         <ActiveFilterChips
       
        groupFilter={groupFilter}
        subgroupFilter={subgroupFilter}
        zoneFilter={zoneFilter}
        serviceFilter={serviceFilter}
        brandFilter={brandFilter}
        onRemoveFilter={handleRemoveFilter}
      />
          </div>
          <div className="cont-buttons-panel" >
               {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["editar cis"]
          ) ? users_catalog.loading?<LoadSimple/>: 
         <Action
                    disabled={false}
                    origen="Cielo"
                    titulo={" Actualizar "+capitalizeFirstLetter(lang[languaje]['masiva'])}
                    action={update_info}
                    hover={false}
                    msg={('Actualizacion masiva')}
                  />:''}
         
                 
 
              </div>
          
                  <div className="cont-buttons-panel" style={{right:'26%'}}>

                        {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["crear cis"]
          ) ? users_catalog.loading?<LoadSimple/>:
                    <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                    action={crear}
                  />:''}
                  
                  
                 
                </div>
                <div className="cont-buttons-panel" style={{right:'13%'}}>
                  
                  {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["crear cis"]
          ) ? users_catalog.loading?<LoadSimple/>:
                    <Action
                    disabled={false}
                    origen="Cielo"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['importar'])}
                    action={import_info}
                  />:''}
                   
                  
                 
                </div>
         {/* <div className='contSearchBtnrange'  style={{left:'0%',position:'relative'}}>
          <div className='compactSearchBtnrange'>
          <Action disabled={false} origen={isOpenAct?'Red':'Cielo'} titulo={isOpenAct?'Cerrar Acciones':'Abrir Acciones'}  action={()=>togglePanelAct()}/>
          <ActionsPanel 
                groupFilter={groupFilter}
                 serviceFilter={serviceFilter}
                 brandFilter={brandFilter}
                zoneFilter={zoneFilter}
                
                import_info={import_info}
                update_info={update_info}
                crear={crear}
                // Pasa las funciones 'setter' para que el hijo pueda actualizarlos
                
                setGroupFilter={setGroupFilter}
                setZoneFilter={setZoneFilter}
                setServiceFilter={setServiceFilter}
                setBrandFilter={setBrandFilter}
                  languaje={languaje}server={server}isOpen={isOpenAct} filters={filters} onFilterChange={handleFilterChange} />
          
          
          </div>
         
         </div> */}
       {/* <div className='contSearchBtnrange'  style={{left:'0%',position:'relative'}}>
          <div className='compactSearchBtnrange'>
          
          </div>
         
         </div> */}
        {/* <div className='contSelectRangeDate' style={{left:'0%',position:'relative'}}>
        <div className="form-GS-box" style={{height:'40%'}}> 
                                    
                                    
                                    
                                    
                                    </div>
        </div> */}
        
       
            </div>
    <div className="head-cis">
        <div className="title-cis">
          <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={dataUsers.data}
                    setDataObject={setDataUsers}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode} style={{width:'20%',left:'5%',position:'absolute'}}>
         
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
            <div className={"cont-result-registers"+mode} style={{width:'27%',left:'3%' , display:'flex' ,bottom:'0px',position:'absolute',right:'5%',justifyContent:'space-between'}}>
         
                  <div style={{  textAlign: "center",color:'var(--second-color)',height:'100%' }}>
                   
                    {'Folios Pendientes'+" (" +
                      (FoliosList.length==0?'':FoliosList.data.length) +
                      ") " 
                      }
                  </div> 
                   {/* <div style={{  textAlign: "center" ,color:'var(--red-alert)',height:'100%' }}>
                   
                    {'Pendientes de Autorización'+" (" +
                    (pendingList.length==0?'':pendingList.data.length)+
                      ") " 
                      }
                  </div>  */}
          </div>
           <div className="cont-buttons-panel" style={{right:'25%', top:'unset'}}>
          <Action disabled={false} origen={'Filtro'} titulo={isOpen?' Filtros':' Filtros'}  action={()=>togglePanel()} icon={isOpen?'close_x':'filtros'}/>
               
           <FilterPanel statusFilter={statusFilter}
                  groupFilter={groupFilter}
                  subgroupFilter={subgroupFilter}
                 serviceFilter={serviceFilter}
                 brandFilter={brandFilter}
                zoneFilter={zoneFilter}
                // Pasa las funciones 'setter' para que el hijo pueda actualizarlos
               setGroupFilter={setGroupFilter}
               setSubGroupFilter={setSubGroupFilter}
                setZoneFilter={setZoneFilter}
                setServiceFilter={setServiceFilter}
                setBrandFilter={setBrandFilter}
                setSeverityFilter={setSeverityFilter}   languaje={languaje}server={server}isOpen={isOpen} filters={filters} onFilterChange={handleFilterChange} />
          
                  
 
              </div>
             
        </div>
      </div>
      
            <div className='cont-cis' style={{height:'77%'}}>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
        
       <div className={"content-portafolio-head"+mode}>
        
        {
        // (contRowsSelected!=0)?
          <>
          {(exportLoading)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
          <>
          {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
          
          <div className="cont-excels-buttons-portafolio" style={{position:'absolute',left:'0%',width:'15%'}}>
          
                     
                      <div className="" style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center'}}>
                      
                        <div className="body-half-excels-buttons-portafolio">
                        {
                          
                          <img
                    className="img-dwnld-portafolio"
                    style={{width:'20px'}}
                    src={"/iconos/refresh.png"}
                    name="refresh"
                    onClick={()=>{buscar_cis();buscar_auths();buscar_folios()}}
                  />
                        }
                        </div>
                        <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'Volver a cargar'}
                        </div>
                      </div>
                 </div>
          {/* <div className="cont-buttons-panel" style={{right:'15%', top:'60%'}}>
               
          <Action
                    disabled={false}
                    origen="Cielo"
                    titulo={" Actualización "+capitalizeFirstLetter(lang[languaje]['masiva'])}
                    action={buscar_cis}
                  />
                 
 
              </div> */}
          <div className="cont-excels-buttons-portafolio" style={{position:'absolute',left:'85%'}}>
          
                     
                      <div className="half-excels-buttons-portafolio">
                      
                        <div className="body-half-excels-buttons-portafolio">
                        {
                          
                          <img
                    className="img-dwnld-portafolio"
                    src={"/iconos/xsl_icon.png"}
                    name="regresar"
                    onClick={()=>Exportar('excel')}
                    style={{opacity:(contRowsSelected==0)? '0.3':'1',
                      pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                  />
                        }
                        </div>
                        <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'EXCEL'}
                        </div>
                      </div>
                 </div>
           </>
          }
          </>
          // :''
              }
              </div>
        <div className="content-portafolio">
          

          <div className="cont-portafolio-table">

            <div className="content-card-portafolio" id="content">
              { dataUsers.loading || loadingCis? (
                <LoadSimple />
              ) : (
                <>
                  {/* {cisSelected.length === 0 ? ( */}
                    <TableCis
                      pageActual={pageActual}
                       limitList={limitList} startLimit={startLimit}
                      dataList={dataList}
                      cisSelected={cisSelected}
                      setCisSelected={setCisSelected}
                      registerIsValid={registerIsValid}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setRegisterIsValid={setRegisterIsValid}
                      setData={setData}
                      setLoading={setLoading}
                      setError={setError}
                      handleChangEdit={handleChangEdit}
                      devices={devices}
                      languaje={languaje}
                      mode={mode}
                      handleShowPopup={handleShowPopup}
                      view={view}
                      setContRowSelected={setContRowSelected}
                      poolRows={poolRows}
                      setPoolRows={setPoolRows}
                      allSelected={allSelected}
                      setPoolObjectRows={setPoolObjectRows}
                      poolObjectRows={poolObjectRows}
                      contRowsSelected={contRowsSelected}
                      setAllSelected={setAllSelected}
                      buscar_cis={buscar_cis}
                      userPermissions={userPermissions}
                      // loadingCis={loadingCis}
                    ></TableCis>
                
                    
                </>
              )}
            </div>
          </div>
        </div>
        <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
            
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                      </p> 
                  
            </div>
          </div>
          <div className="cont-display-paginador">
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador">
            <div className={"cont-half-display-paginador"+mode}>
            <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
                  
            </div>
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                  
            </div>
          </div>  
                    
        </div>
        </div>
      </div>
      </>
                
                
            </div>
      <Modal
        isOpen={CreateCisModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closCreateCisModal}
        style={CreateCisModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
      <ModalMain 
      devices={devices}
            server={server}
            editActive={editActive}
            setEditActive={setEditActive}
            dataCis={dataCis}
            setData={setData}
            loading={loading}
            setLoading={setLoading}
            setError={setError}
            setRegisterIsValid={setRegisterIsValid}
            closCreateCisModal={closCreateCisModal}
            languaje={languaje}
            mode={mode}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            handleShowPopup={handleShowPopup}
            buscar_cis={buscar_cis}
            users_catalog={users_catalog}
            buscar_auths={buscar_auths}
            buscar_folios={buscar_folios}
      />  

      
          {/* <ModalCreateCis
            devices={devices}
            server={server}
            editActive={editActive}
            setEditActive={setEditActive}
            dataCis={dataCis}
            setData={setData}
            loading={loading}
            setLoading={setLoading}
            setError={setError}
            setRegisterIsValid={setRegisterIsValid}
            closCreateCisModal={closCreateCisModal}
            languaje={languaje}
            mode={mode}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            handleShowPopup={handleShowPopup}
          ></ModalCreateCis> */}
      </Modal>
      <Modal
        isOpen={infoCisModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closinfoCisModal}
        style={infoCreateCisModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
      <ModalMenuHost
      devices={devices}
      server={server}
      editActive={editActive}
      setEditActive={setEditActive}
      dataCis={dataCis}
      setData={setData}
      loading={loading}
      setLoading={setLoading}
      setError={setError}
      dataUsers={dataUsers}
      setRegisterIsValid={setRegisterIsValid}
      closCreateCisModal={closinfoCisModal}
      groupSelected={1}
      languaje={languaje}
      mode={mode}
      setSearchTerm={setSearchTerm}
      handleShowPopup={handleShowPopup}
      buscar_cis={buscar_cis}
      cisSelected={cisSelected}
      setCisSelected={setCisSelected}
    ></ModalMenuHost>
    </Modal>
     <Modal
        isOpen={ImportModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeImportModal}
        style={ImportModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={true}
      >
      <ImportCis
      users_catalog={users_catalog}
      server={server}
      importLoading={importLoading}
      setImportLoading={setImportLoading}
      closeImportModal={closeImportModal}
      languaje={languaje}
      mode={mode}
      handleShowPopup={handleShowPopup}
      buscar_cis={buscar_cis}
    ></ImportCis>
    </Modal>

     <Modal
        isOpen={ImportModalOpen2}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeImportModal2}
        style={ImportModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={true}
      >
      <UpdateCis
      users_catalog={users_catalog}
      server={server}
      importLoading={importLoading}
      setImportLoading={setImportLoading}
      closeImportModal={closeImportModal2}
      languaje={languaje}
      mode={mode}
      handleShowPopup={handleShowPopup}
      buscar_cis={buscar_cis}
      buscar_auths={buscar_auths}
      buscar_folios={buscar_folios}
      poolRows={poolRows}
      poolObjectRows={poolObjectRows}
      setPoolObjectRows={setPoolObjectRows} 
      setPoolRows={setPoolRows}
      datacis={dataUsers}
    ></UpdateCis>
    </Modal>
    </>
  );
};

export default PanelCis;
